export enum TelematicsStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
  STALE = 'stale',
}

export enum TelematicsConnectionStatus {
  CONNECTED = 'connected',
  DEACTIVATED = 'deactivated',
  DISCONNECTED = 'disconnected',
  UNDETECTED_VIN = 'undetectedVin',
  READY_TO_CONNECT = 'readyToConnect',
}

export enum DeviceTableTab {
  Activated,
  Deactivated,
}

export enum DevicelessTableTab {
  Active,
  Pending,
  Failed,
}

export enum OEMNames {
  BMW = 'bmw',
  FORD = 'ford',
  GENERAL_MOTORS = 'general motors',
  HYUNDAI = 'hyundai',
  MERCEDES_BENZ = 'mercedes-benz',
  RIVIAN = 'rivian',
  STELLANTIS = 'stellantis',
  TOYOTA = 'toyota',
  VOLKSWAGEN = 'volkswagen',
  VOLVO = 'volvo',
  ZUBIE = 'zubie',
}
